"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQrSize = exports.RECOMMENDED_URL_LENGTH = void 0;
const RECOMMENDED_URL_LENGTH = exports.RECOMMENDED_URL_LENGTH = 50; // minified

const getQrSize = url => {
  if (url.length < RECOMMENDED_URL_LENGTH) {
    return 198;
  }
  if (url.length < 100) {
    return 256;
  }
  return 300;
};
exports.getQrSize = getQrSize;
